import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrossLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cross-large, crossed large, close"} maskId="square-filled-radius-0-stroke-1-IconCrossLarge"><path fillRule="evenodd" clipRule="evenodd" d="M4.75003 3.33594L12 10.5859L19.25 3.33594L20.6642 4.75015L13.4142 12.0002L20.6642 19.2502L19.25 20.6644L12 13.4144L4.75003 20.6644L3.33582 19.2502L10.5858 12.0002L3.33582 4.75015L4.75003 3.33594Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrossLarge;
